import React, { useState } from "react";
import { Row, Typography, Button, Col, Form, Input, Select, Spin } from "antd";
import {
  ArrowLeftOutlined,
  EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { editAccountInitialValues as initialValues } from "./initialValues";
import styles from "./styles/EditAccountPage.module.css";
import { updateMyAccount } from "../../http-request/user";
import Notification from "../../../components/shared/Notification";
import { COLORS } from "../../../constants";

const { Paragraph, Title } = Typography;

function EditAccount() {
  const labels = [
    "Email",
    "First Name",
    "Last Name",
    "Gender",
    "Phone Number",
    "User Level",
  ];

  const gender = [{ value: "Male" }, { value: "Female" }, { value: "Others" }];
  const userLevels = [{ value: "Admin" }, { value: "Staff" }];
  const [isUpdating, setisUpdating] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: COLORS.blue1 }} spin />
  );

  return (
    <div className={styles.container}>
      <center>
        <div className={styles.content}>
          <Row align="middle" justify="space-between" style={{ marginTop: 20 }}>
            <Link to={-1}>
              <ArrowLeftOutlined style={{ fontSize: 20 }} />
            </Link>
            <Title level={3} style={{ textAlign: "right" }}>
              Edit Account
            </Title>
          </Row>
          <Form
            initialValues={state?.user || initialValues}
            onFinish={async (data) => {
              setisUpdating(true);
              await updateMyAccount(data)
                .then((data) => {
                  if (data?.didUpdate) {
                    Notification("User successfully updated!", "", "success");
                    navigate(-1, { replace: true });
                  }
                })
                .finally(() => setisUpdating(false));
            }}
          >
            <div className={styles.info}>
              {Object.keys(initialValues).map((item, index) => (
                <Row key={index} justify="center" gutter={10} align="middle">
                  <Col span={8}>
                    <Paragraph style={{ textAlign: "left" }}>
                      <strong> {labels[index]}:</strong>
                    </Paragraph>
                  </Col>
                  <Col span={14}>
                    {labels[index] === "Gender" ? (
                      <Form.Item
                        name={item}
                        rules={[
                          {
                            required: true,
                            message: `Please input ${labels[index]}`,
                          },
                        ]}
                      >
                        <Select
                          options={gender}
                          style={{ textAlign: "left" }}
                        />
                      </Form.Item>
                    ) : labels[index] === "User Level" ? (
                      <Form.Item
                        name={item}
                        rules={[
                          {
                            required: true,
                            message: `Please input ${labels[index]}`,
                          },
                        ]}
                      >
                        <Select
                          options={userLevels}
                          style={{ textAlign: "left" }}
                        />
                      </Form.Item>
                    ) : labels[index] === "Email" ? (
                      <Form.Item
                        name={item}
                        rules={[
                          {
                            type: "email",
                            message: "The input is not valid E-mail!",
                          },
                          {
                            required: true,
                            message: `Please input ${labels[index]}`,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    ) : (
                      <Form.Item
                        name={item}
                        rules={[
                          {
                            required: true,
                            message: `Please input ${labels[index]}`,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    )}
                  </Col>
                </Row>
              ))}
            </div>
            <Button
              disabled={isUpdating ? true : false}
              block
              type="primary"
              htmlType="submit"
              icon={!isUpdating && <EditOutlined />}
            >
              {isUpdating ? <Spin indicator={antIcon} /> : "UPDATE ACCOUNT"}
            </Button>
          </Form>
        </div>
      </center>
    </div>
  );
}

export default EditAccount;
